import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRealTimeTranscription = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 17,
	viewBox: "0 0 18 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.8216 1.38102C15.6625 1.38102 17.1549 2.87341 17.1549 4.71436V13.0477C17.1549 14.8886 15.6625 16.381 13.8216 16.381H3.82162C1.98067 16.381 0.488283 14.8886 0.488283 13.0477V10.131H2.15495V13.0477C2.15495 13.9682 2.90114 14.7144 3.82162 14.7144H13.8216C14.7421 14.7144 15.4883 13.9682 15.4883 13.0477V4.71436C15.4883 3.79388 14.7421 3.04769 13.8216 3.04769H7.15495V1.38102H13.8216ZM13.8216 8.04769H11.3216V13.0477H9.65495V8.04769H7.15495V6.38102H13.8216V8.04769ZM3.53597 0C4.7424 1.20643 5.48828 2.87341 5.48828 4.71436C5.48828 6.55531 4.7424 8.22227 3.53597 9.42869L2.35677 8.24953C3.26159 7.34469 3.82162 6.09507 3.82162 4.71436C3.82162 3.33365 3.26159 2.08403 2.35677 1.1792L3.53597 0ZM1.17838 2.35759C1.7816 2.9608 2.15495 3.79388 2.15495 4.71436C2.15495 5.63483 1.7816 6.46792 1.17838 7.07113L0 5.89274C0.301608 5.59113 0.488283 5.17459 0.488283 4.71436C0.488283 4.25412 0.301608 3.83758 0 3.53597L1.17838 2.35759Z",
		fill: "#4A4D53"
	})]
});
const ForwardRef = forwardRef(SvgRealTimeTranscription);
export { ForwardRef as ReactComponent };
